import { Typography } from 'antd';

interface Props {
  className: string;
}
const CopyRight = ({ className }: Props): JSX.Element => {
  return (
    <Typography.Text className={className}>
      © {`${Number(new Date().getFullYear())}`} TCX. All rights reserved
    </Typography.Text>
  );
};

export default CopyRight;
